import { render, staticRenderFns } from "./betail.vue?vue&type=template&id=31a50b43&scoped=true"
import script from "./betail.vue?vue&type=script&lang=js"
export * from "./betail.vue?vue&type=script&lang=js"
import style0 from "./betail.vue?vue&type=style&index=0&id=31a50b43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a50b43",
  null
  
)

export default component.exports